import { useState, useCallback, useContext } from 'react';
import { sendChatMessage } from '../services/ai';
import { Context } from '../store/Store';

export function useChat() {
  const { app } = useContext(Context);
  const [messages, setMessages] = useState([
    { role: 'assistant', content: 'Bonjour ! Comment puis-je vous aider ?' }
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [pendingRecap, setPendingRecap] = useState(null);
  const [tone, setTone] = useState('empathique');

  const sendMessage = useCallback(async (content) => {
    if (!content.trim() || isLoading) return;

    // Ajouter le message user
    const userMessage = { role: 'user', content };
    setMessages(prev => [...prev, userMessage]);
    setIsLoading(true);
    setSuggestions([]);

    // Préparer le message assistant (streaming)
    let assistantContent = '';
    setMessages(prev => [...prev, { role: 'assistant', content: '', isStreaming: true }]);

    await sendChatMessage({
      message: content,
      tone,
      conversationHistory: messages.map(m => ({ role: m.role, content: m.content })),
      context: {
        producteurId: app.profil?.id,
        producteurName: app.profil?.name
      },
      onEvent: (eventType, data) => {
        if (eventType === 'delta') {
          assistantContent += data.content;
          setMessages(prev => {
            const updated = [...prev];
            updated[updated.length - 1] = {
              role: 'assistant',
              content: assistantContent,
              isStreaming: true
            };
            return updated;
          });
        } else if (eventType === 'suggestions') {
          setSuggestions(data);
        } else if (eventType === 'submission_success') {
          setPendingRecap(null);
          // Le message de succès sera dans le stream
        } else if (eventType === 'tool_call' && data.name === 'submit_annonce') {
          setPendingRecap(data.input);
        }
      },
      onEnd: () => {
        setMessages(prev => {
          const updated = [...prev];
          if (updated.length > 0) {
            updated[updated.length - 1].isStreaming = false;
          }
          return updated;
        });
        setIsLoading(false);
      },
      onError: (error) => {
        console.error('Chat error:', error);
        setMessages(prev => {
          const updated = [...prev];
          updated[updated.length - 1] = {
            role: 'assistant',
            content: 'Désolé, une erreur est survenue. Réessayez.',
            isError: true
          };
          return updated;
        });
        setIsLoading(false);
      }
    });
  }, [messages, tone, isLoading, app.profil]);

  const clearChat = useCallback(() => {
    setMessages([{ role: 'assistant', content: 'Bonjour ! Comment puis-je vous aider ?' }]);
    setSuggestions([]);
    setPendingRecap(null);
  }, []);

  return {
    messages,
    isLoading,
    suggestions,
    pendingRecap,
    tone,
    setTone,
    sendMessage,
    clearChat
  };
}
